import React from 'react';

import "./Loader.css";

const Loader = () => {
  return (
    <div className='loader flex flex-c'>
      <h3>Loading...</h3>
    </div>
  )
}

export default Loader